import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import GuideLanguageService from "../../../../services/catalogs/GuideLanguageService";

export const REQUEST_FETCH_GUIDE_LANGUAGE = "REQUEST_FETCH_GUIDE_LANGUAGE";
export const FETCH_GUIDE_LANGUAGE_SUCCESS = "FETCH_GUIDE_LANGUAGE_SUCCESS";
export const FETCH_GUIDE_LANGUAGE_ERROR = "FETCH_GUIDE_LANGUAGE_ERROR";
export const INITIAL_STATE_GUIDE_LANGUAGE = "INITIAL_STATE_GUIDE_LANGUAGE";

function requestFetchGuideLanguage() {
  return {
    type: REQUEST_FETCH_GUIDE_LANGUAGE,
  };
}

function fetchGuideLanguageSuccess(json) {
  return {
    type: FETCH_GUIDE_LANGUAGE_SUCCESS,
    guideLanguage: json.data,
  };
}

function fetchGuideLanguageError(json) {
  return {
    type: FETCH_GUIDE_LANGUAGE_ERROR,
    error: json.data,
  };
}

export function initialStateGuideLanguage() {
  return {
    type: INITIAL_STATE_GUIDE_LANGUAGE,
  };
}

export function fetchGuideLanguage(guide_id, id) {
  return (dispatch) => {
    dispatch(requestFetchGuideLanguage());
    return GuideLanguageService.getGuideLanguage(guide_id, id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchGuideLanguageSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchGuideLanguage(guide_id, id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchGuideLanguageError(json.data));
      }
    });
  };
}
